import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import Header from "../components/Header";
import Chapters from "../components/Chapters";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import Checkout from "../components/Checkout";
import { useCart } from "../context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VoyageDecoration() {
  const [products, setProducts] = useState([]);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const { setOpen } = useCart();

  useEffect(() => {
    axios.get(`${API}/products`).then(({ data }) => setProducts(data.filter((p) => p.chapter >= 4))).catch(() => {});
  }, []);

  useEffect(() => {
    if (products.length && window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [products]);

  return (
    <div data-testid="voyage-decoration-page" className="min-h-screen bg-ivory">
      <Header />
      <section data-testid="voyage-hero" className="luminous pt-36 md:pt-48 pb-4 md:pb-8">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="block text-sm uppercase tracking-[0.35em] text-gold"
          >
            L'évasion & la maison
          </motion.span>
          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="font-serif font-light text-choco text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-5"
          >
            Le Voyage <span className="text-gold">✦</span> la Décoration
          </motion.h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.6 }}
            className="font-accent italic text-lg text-choco/90 mt-4 max-w-xl"
          >
            Des compagnons de route élégants, et une maison qui réchauffe — l'univers KARYNA vous suit partout.
          </motion.p>
        </div>
      </section>
      <Chapters products={products} />
      <Footer />
      <CartDrawer onCheckout={() => { setOpen(false); setCheckoutOpen(true); }} />
      <Checkout open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
    </div>
  );
}
